"use client";
import Link from "next/link";
import { useState } from "react";
import { usePathname } from "next/navigation";
import menuData from "./menuData";
import { Menu } from "@/types/menu";

const DesktopNav = () => {
  const pathname = usePathname();
  const [hoverIndex, setHoverIndex] = useState(-1);

  return (
    <nav className="hidden lg:flex lg:items-center lg:space-x-8">
      {menuData.map((menuItem: Menu, index: number) => {
        const isSubmenuActive = menuItem?.submenu?.some(
          (submenu) => submenu.path && pathname.startsWith(submenu.path),
        );
        const isActive = pathname === menuItem.path || isSubmenuActive;

        return (
          <div
            key={index}
            className="group relative"
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(-1)}
          >
            {menuItem.path ? (
              <Link
                href={menuItem.path}
                className={`text-base font-medium transition-colors duration-200 ${
                  isActive
                    ? "text-primary dark:text-white"
                    : "hover:text-primary text-gray-700 dark:text-gray-300 dark:hover:text-white"
                }`}
              >
                {menuItem.title}
              </Link>
            ) : (
              <>
                <button
                  className={`flex items-center space-x-1 text-base font-medium transition-colors duration-200 ${
                    isActive
                      ? "text-primary dark:text-white"
                      : "hover:text-primary text-gray-700 dark:text-gray-300 dark:hover:text-white"
                  }`}
                >
                  <span>{menuItem.title}</span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 24"
                    className="transition-transform duration-200"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.29289 8.8427C6.68342 8.45217 7.31658 8.45217 7.70711 8.8427L12 13.1356L16.2929 8.8427C16.6834 8.45217 17.3166 8.45217 17.7071 8.8427C18.0976 9.23322 18.0976 9.86639 17.7071 10.2569L12 15.964L6.29289 10.2569C5.90237 9.86639 5.90237 9.23322 6.29289 8.8427Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
                <div
                  className={`absolute left-0 mt-2 min-w-[180px] rounded-md bg-white shadow-lg transition-all duration-300 ease-in-out dark:bg-gray-800 ${
                    hoverIndex === index
                      ? "visible translate-y-0 opacity-100"
                      : "invisible -translate-y-2 opacity-0"
                  }`}
                >
                  <ul className="py-2">
                    {menuItem?.submenu?.map(
                      (submenuItem: Menu, subIndex: number) => (
                        <li key={subIndex}>
                          <Link
                            href={submenuItem.path ?? ""}
                            className={`block px-4 py-2 text-sm transition-colors ${
                              pathname === submenuItem.path
                                ? "text-primary bg-gray-100 dark:bg-gray-700 dark:text-white"
                                : "hover:text-primary text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white"
                            }`}
                          >
                            {submenuItem.title}
                          </Link>
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              </>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default DesktopNav;
